import { Box } from "@mui/material";
import { DotLegalTooltip } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../localization/useTranslation";
import { warningIcon } from "../../icons";

// Marks a role that holds ContractFullAccess, SystemFullAccess or IncidentLogFullAccess. Those bypass row-level access entirely, so the
// grant is surfaced everywhere a role is named rather than only inside the role permission dialog.
export default function FullAccessWarningIcon() {
    const { translateString } = useTranslation();

    return (
        <DotLegalTooltip text={translateString("roleHasFullAccessWarning")}>
            <Box
                component="span"
                sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    marginLeft: 0.5,
                    color: (theme) => theme.palette.warning.main,
                    // 14px matches the inline table-icon size already used on the users overview (Users.styles.ts),
                    // and keeps the triangle from towering over the role names it annotates.
                    "& svg": {
                        width: 14,
                        height: 14,
                    },
                }}
            >
                {warningIcon}
            </Box>
        </DotLegalTooltip>
    );
}
